import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { PinchZoomComponent } from '@meddv/ngx-pinch-zoom';

import { NodeType } from '@reach/interfaces/nodes/node-type.enum';

import { CommonImgDirective } from '~ng-common-lib/cdk/img';
import { Http2HttpsPipe } from '~ng-common-lib/core/pipes/http-to-https.pipe';
import { ClientNode } from '~ng-common-lib/nodes/types/node';

@Component({
	selector: 'image-preview',
	templateUrl: './image.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [CommonModule, PinchZoomComponent, Http2HttpsPipe, CommonImgDirective],
	host: {
		class: 'block',
	},
})
export class ImagePreviewComponent {
	public readonly $file = input.required<ClientNode<NodeType.FILE>>({
		alias: 'file',
	});

	public readonly $showError = signal(false);

	public onError(): void {
		this.$showError.set(true);
	}
}
